module.exports = __webpack_public_path__ + "img/DASH-alt.b6ef8de5.svg";